import axios from 'axios';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getUniqueDocument: (unique_document_id, options) => {
    let url = process.env.REACT_APP_API +
    '/unique_documents/' +
    unique_document_id +
    '?current_company=' +
      localStorage.current_company_id;
    
    if (options && options.recordDescriptor) {
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/uniqueDocumentsServices.js